import React from "react";
import { IndexScores } from "../../../http";
import styles from "../styles/ChatbotWindow.module.css";

interface Props {
  scores: IndexScores;
}

const ScoreCard: React.FC<Props> = ({ scores }) => (
  <div className={styles.scoreGrid}>
    {Object.entries(scores).map(([key, val]) => (
      <div key={key} className={styles.scoreItem}>
        <span className={styles.scoreLabel}>{key.replace(/_/g, " ")}</span>
        <span
          className={styles.scoreValue}
          style={{ color: val >= 100 ? "#E961AB" : val >= 50 ? "#F68524" : "#EA1515" }}
        >
          {val}%
        </span>
      </div>
    ))}
  </div>
);

export default ScoreCard;
